<template>
  <fragment>
    <page-head
      small
      :title="local.caseFile.lawsuitReplyForm.defendantResponseTitle"
    >
    </page-head>
    <page-content small>
      <v-form
        ref="responseFormRef"
        @submit.prevent="validateThenSubmit"
      >
        <v-row>
          <div
            v-if="false"
            class="px-5 text-h6 font-weight-black mt-3 text-c-green"
          >
            {{ local.caseFile.lawsuitReplyForm.defendantResponseTitle }}
          </div>
        </v-row>

        <v-row>
          <v-col
            cols="6"
            class="mt-3 px-5"
          >
            <naj-input
              :type-id="formFieldType.multipleSelectBox"
              :value.sync="formModel.applicantPartyIds"
              :label="local.caseFile.lawsuitReplyForm.selectPartiesToRespond"
              :items="defendants"
              item-value="partyId"
              item-text="name"
              validates="required"
              :disabled="casePartiesSelectboxDisabled"
            ></naj-input>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="px-5"
          >
            <naj-item-description
              :title="local.caseFile.caseSubject"
              :message="caseDetails.caseSubject"
              :no-data-message=" local.caseFile.noCaseSubject"
            >
            </naj-item-description>
          </v-col>
        </v-row>

        <template v-if="canAddFormalizedNote">
          <v-row>
            <v-col
              cols="12"
              class="mt-12 px-8"
            >
              <naj-dynamic-form
                v-if="dynamicForm"
                :form-model="formModel"
                :form-fields="dynamicForm.fields"
                :custom-component-name="dynamicForm.customComponentName"
                :disabled="isViewMode"
                @change="dynamicFormChanged"
              >
              </naj-dynamic-form>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              class="px-5"
            >
              <naj-item-description
                :title="local.caseFile.caseDemands"
                :message="caseDetails.caseDemands"
                :no-data-message=" local.caseFile.noCaseDemands"
              >
              </naj-item-description>
            </v-col>
          </v-row>

          <v-row class="mt-10">
            <div class="px-5 text-h6 font-weight-black mt-3 text-c-green">
              {{ local.caseFile.lawsuitReplyForm.requestsAnswers }}
            </div>
          </v-row>

          <div
            v-for="(request, index ) in formModel.requests"
            :key="index"
            class="row"
          >
            <div
              v-if="request.formId"
              class="px-5 col-4"
            >
              <naj-input
                :type-id="formFieldType.selectbox "
                :value.sync="request.requestDataAnswer "
                :value-name.sync="request.requestDataAnswerName"
                :label="`${local.caseFile.lawsuitReplyForm.requestQuestionFirstSection} ${request.name}`"
                :items="correctOrInCorrect"
                item-value="id"
                item-text="name"
                :technical-name="`caseRequest${request.id}${request.name}`"
                validates="required"
                :disabled="isViewMode"
              ></naj-input>
            </div>
            <div
              v-if="request.formId"
              class="px-5 col-4"
            >
              <naj-input
                :type-id="formFieldType.text"
                :value.sync="request.responseTemplatePartiallyCorrectResult"
                :label="local.caseFile.lawsuitReplyForm.correctPart"
                :validates="`${request.requestDataAnswer == 3 ? 'required' : ''}`"
                :disabled="request.requestDataAnswer != 3 || isViewMode"
              ></naj-input>
            </div>
            <div
              v-if="request.formId"
              class="px-5 col-4"
            >
              <naj-input
                :type-id="formFieldType.text"
                :value.sync="request.responseTemplateCorrectResult"
                :label="local.caseFile.lawsuitReplyForm.infoCorrection"
                :validates="`${(request.requestDataAnswer == 3 || request.requestDataAnswer == 2) ? 'required' : ''}`"
                :disabled="(request.requestDataAnswer != 2 && request.requestDataAnswer != 3) || isViewMode"
              ></naj-input>
            </div>

            <div class="px-5 col-4">
              <naj-input
                :type-id="formFieldType.selectbox "
                :value.sync="request.requestAnswer "
                :value-name.sync="request.requestAnswerName"
                :label="`${local.caseFile.lawsuitReplyForm.agreeOrNotAgreeQuestion} ${request.name}`"
                :items="agreeNotAgree"
                item-value="id"
                item-text="name"
                :technical-name="`caseRequest${request.id}${request.name}`"
                validates="required"
                :disabled="isViewMode"
              ></naj-input>
            </div>

            <div class="px-5 col-4">
              <naj-input
                :technical-name="`request_conditionallyAgree${index}${request.id}${request.name}`"
                :type-id="formFieldType.text"
                :value.sync="request.condinanllyAgree"
                :label="local.caseFile.lawsuitReplyForm.theCondition"
                :validates="`${request.requestAnswer == 3 ? 'required' : ''}`"
                :disabled="request.requestAnswer != 3 || isViewMode"
              ></naj-input>
            </div>
            <div
              v-if="request.requestAnswer != 4"
              class="px-5 col-4"
            >
              <naj-input
                :technical-name="`request_rejection${index}${request.id}${request.name}`"
                :type-id="formFieldType.text"
                :value.sync="request.rejectionReason"
                :label="local.caseFile.lawsuitReplyForm.reasonNotToAgree"
                :validates="`${request.requestAnswer == 2 ? 'required' : ''}`"
                :disabled="request.requestAnswer != 2 || isViewMode"
              ></naj-input>
            </div>
            <div
              v-if="request.requestAnswer == 4"
              class="px-5 col-4"
            >
              <naj-input
                :technical-name="`request_otherOption${index}${request.id}${request.name}`"
                :type-id="formFieldType.text"
                :value.sync="request.otherOption"
                :label="local.caseFile.lawsuitReplyForm.others"
                :validates="`${request.requestAnswer == 4 ? 'required' : ''}`"
                :disabled="request.requestAnswer != 4 || isViewMode"
              ></naj-input>
            </div>
          </div>

          <v-row class="mt-10">
            <div class="px-5 text-h6 font-weight-black mt-3 text-c-green">
              {{ local.caseFile.lawsuitReplyForm.defendantAdditionalRequirement }}
            </div>
          </v-row>

          <div class="row">
            <div class="px-5 col-4">
              <naj-input
                :type-id="formFieldType.selectbox"
                :value.sync="formModel.newRequirementVal"
                :value-name.sync="formModel.newRequirementValName"
                :label="local.caseFile.lawsuitReplyForm.newRequirementQuestion"
                :items="additionalRequirement"
                item-value="id"
                item-text="name"
                technical-name="additionalRequirementName"
                validates="required"
                :disabled="isViewMode"
              ></naj-input>
            </div>
            <div class="px-5 col-8">
              <naj-input
                :type-id="formFieldType.text"
                :value.sync="formModel.newRequirementText"
                :label="local.caseFile.lawsuitReplyForm.newRequirement"
                :validates="`${formModel.newRequirementVal == 1 ? 'required' : ''}`"
                :disabled="formModel.newRequirementVal != 1 || isViewMode"
              ></naj-input>
            </div>
            <div class="px-5 col-4">
              <naj-input
                :type-id="formFieldType.selectbox"
                :value.sync="formModel.newRequestVal"
                :value-name.sync="formModel.newRequestValName"
                :label="local.caseFile.lawsuitReplyForm.newRequestQuestion"
                :items="additionalRequests"
                item-value="id"
                item-text="name"
                technical-name="additionalRequestsName"
                validates="required"
                :disabled="isViewMode"
              ></naj-input>
            </div>

            <div class="px-5 col-8">
              <naj-input
                :type-id="formFieldType.text"
                :value.sync="formModel.newRequestText"
                :label="local.caseFile.lawsuitReplyForm.newRequest"
                :validates="`${formModel.newRequestVal == 1 ? 'required' : ''}`"
                :disabled="formModel.newRequestVal != 1 || isViewMode"
              ></naj-input>
            </div>
          </div>
        </template>

        <v-row>
          <div class="px-5 text-h6 font-weight-black mt-3 text-c-green">
            {{ local.attachments.title }}
          </div>
        </v-row>

        <div class="attachments-wrapper">
          <v-col
            v-if="formModel.attachments.length > 0"
            cols="12"
            class="px-5"
          >
            <naj-box
              v-for="(file,index) in formModel.attachments"
              :key="index"
              :title="file.fileName"
            >
              <v-row>
                <v-col cols="10">
                  <label class="request-reason-label"> اسم المرفق</label>
                  <div>
                    <span class="request-reason-text">
                      {{ file.fileName }}
                    </span>
                  </div>
                </v-col>

                <v-col
                  class="d-flex justify-content-end align-items-center"
                  cols="2"
                >
                  <v-btn
                    icon
                    @click="handleViewAttachment(file)"
                  >
                    <v-icon>
                      mdi-eye
                    </v-icon>
                  </v-btn>

                  <v-btn
                    v-if="!isViewMode"
                    icon
                    @click="activeAttachment = index;
                            deleteModalVisibility = true"
                  >
                    <v-icon color="red">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </naj-box>
          </v-col>

          <v-col
            v-if="!isViewMode "
            cols="1"
            class="mb-6 px-5"
          >
            <naj-button
              icon="mdi-plus"
              @click="showModal"
            >
            </naj-button>
          </v-col>
        </div>

        <v-row>
          <v-col
            cols="12"
            class="px-5"
          >
            <naj-input
              :type-id="formFieldType.textarea"
              :label="local.caseRelatedRequest.addNoteRequest.noteText"
              :value.sync="formModel.responseReplyNote"
              rows="8"
              validates="required|max:1000000"
              :disabled="isViewMode || canAddFormalizedNote"
            ></naj-input>
          </v-col>
        </v-row>
      </v-form>

      <v-row>
        <v-col
          cols="12"
          class="text-left"
        >
          <naj-button
            outlined
            @click="$router.back()"
          >
            {{ local.common.back }}
          </naj-button>

          <naj-button @click="validateThenSubmit">
            {{ local.common.saveAndSend }}
          </naj-button>
          <naj-confirmation
            :show-modal="showConfirmationModal"
            :title="local.caseFile.lawsuitReplyForm.confirmationSendReply"
            :message="local.caseFile.lawsuitReplyForm.sendReplyConfirmationMessage"
            :ok-btn-label="local.common.yes"
            :close-btn-label="local.common.no"
            @ok="onSubmit"
            @cancel="showConfirmationModal = false"
          ></naj-confirmation>
        </v-col>
      </v-row>
      <qaim-evaluation
        v-if="showEvaluationModal"
        :request-evaluations-code="qaimConfig.requestEvaluationsCodes.lawsuitReplyForm"
        :ref-num="requestCodeResult"
        :is-lawsuit-request="false"
      >
      </qaim-evaluation>
      <attachment-modal
        ref="attachmentModalComponent"
        :attachment="selectedAttachment"
        :attachment-categories="attachmentCategories"
        :attachments-data="attachmentsDataArray"
        modal-button-text=""
        :action-text="local.attachments.addToRequest"
        :view-mode="isViewMode"
        :max-file-size="5"
        @onClose="attachmentModalClosed"
        @onSubmit="submitUploadAttachment"
      ></attachment-modal>

      <naj-confirmation
        :show-modal="deleteModalVisibility"
        color="error"
        :title="local.common.removeConfirmation"
        :message="local.common.removeConfirmationMessage"
        :ok-btn-label="local.common.remove"
        @ok="() => {
          deleteModalVisibility = false;
          handleDeleteAttachment();
        }"
        @cancel="deleteModalVisibility = false"
      ></naj-confirmation>
    </page-content>
  </fragment>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapState, mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers('LookupsModule');
const { mapState: mapLawsuitState } = createNamespacedHelpers('LawsuitModule');

import { casePartyRoleEnum } from '@/helpers/enum';
import { resetScroll } from '@/helpers/utils';
import AttachmentModal from '@/components/shared/attachment-modal/index';
import qaimEvaluation from '@/modules/lawsuit/components/qaim-evaluations';

export default {
  name: 'LawsuitReplyForm',
  components: {
    AttachmentModal,
    qaimEvaluation,
  },
  props: {},
  data() {
    return {
      showEvaluationModal: false,
      requestCodeResult: '',
      formModel: { attachments: [] },
      caseDetails: {},
      caseTypeInfo: {},
      dynamicForm: null,
      caseParties: [],
      userCasePartyRoleInCase: {},
      isLoggedInUserExistsAsCaseParty: false,
      neglectFirstDynamicFormChange: false,
      loading: false,
      canAddFormalizedNote: false,
      isViewMode: false,
      showConfirmationModal: false,
      selectedAttachment: null,
      deleteModalVisibility: false,
      activeAttachment: null,
    };
  },
  computed: {
    ...mapLawsuitState({ attachmentsData: state => state.attachments.data }),
    ...mapLUTState(['agreeNotAgree', 'additionalRequirement', 'additionalRequests', 'correctOrInCorrect', 'attachmentCategories']),
    ...mapState({ qaimConfig: state => state.qaimConfig }),
    caseObjectKey() {
      return this.$route.params.caseObjectKey;
    },
    isPega() {
      return this.$route.params.isPega;
    },
    attachmentsDataArray() {
      return Object.values(this.attachmentsData);
    },
    defendants() {
      return (this.caseParties || []).filter(cp => cp.casePartyRole == casePartyRoleEnum.defendant);
    },
    prosecutors() {
      return (this.caseParties || []).filter(cp => cp.casePartyRole == casePartyRoleEnum.prosecutor);
    },
    casePartiesSelectboxDisabled() {
      return this.isViewMode || ((this.formModel.applicantPartyIds || []).length > 0 && this.isLoggedInUserExistsAsCaseParty);
    },
  },
  mounted() {
    this.loadData();
    this.getAttachmentCategories();
  },
  methods: {
    ...mapActions([
      'getCaseRequestApplicants',
      'getUserCasePartyRoleInCase',
      'getCaseInfo',
      'getLawsuitSubjectByCaseCode',
      'addLawsuitReplyResponseForm',
      'uploadAttachment',

    ]),
    ...mapGlobalActions(['getDynamicForm', 'getCaseType']),
    ...mapLUTActions(['getAttachmentCategories']),

    loadData() {
      this.loading = true;
      const params = {
        objectKey: this.caseObjectKey,
        isPega: this.isPega,
      };

      Promise.all([
        this.getCaseRequestApplicants(params),
        this.getUserCasePartyRoleInCase(params),
        this.getCaseInfo(params),
      ])
        .then((res) => {
          this.caseParties = res[0].data.requestApplicants;
          this.userCasePartyRoleInCase = res[1].data;
          this.caseDetails = res[2].data;
          this.setRelatedPartyAsRequestApplicant();
          this.getCaseTypeInfo();
        })
        .finally(() => (this.loading = false));
    },
    setRelatedPartyAsRequestApplicant() {
      const selectedParty = this.defendants.find(cp => cp.partyId == this.userCasePartyRoleInCase.partyId);
      if (selectedParty) {
        this.isLoggedInUserExistsAsCaseParty = true;
        this.$set(this.formModel, 'applicantPartyIds', [selectedParty.partyId]);
      }
    },
    getCaseTypeInfo() {
      if (this.caseDetails.caseTypeId) {
        this.getCaseType(this.caseDetails.caseTypeId)
          .then((res) => {
            this.caseTypeInfo = res;
            this.getResponseForm();
          });
      }
    },
    getResponseForm() {
      if (this.caseTypeInfo && this.caseTypeInfo.responseFormId) {
        this.getDynamicForm({
          formId: this.caseTypeInfo.responseFormId,
          withoutParse: true,
        })
          .then((res) => {
            this.dynamicForm = res;
            this.getLawsuitSubject();
          });
      }
    },
    getLawsuitSubject() {
      this.getLawsuitSubjectByCaseCode(this.caseDetails.caseCode)
        .then((res) => {
          if (res.data && res.data.forms && res.data.forms.length > 0) {
            const model = {
              ...this.formModel,
              ...res.data.forms[0],
            };
            this.$set(this, 'formModel', model);
            this.canAddFormalizedNote = true;
          }
        });
    },
    getResponseDynamicFormFieldsFlattered() {
      if (!this.dynamicForm) {
        return [];
      }
      const sections = (this.dynamicForm.fields || []).filter(a => a.typeId == 11);
      const sectionsFields = [].concat.apply([], sections.map(a => a.fields));
      const unParentFields = (this.dynamicForm.fields || []).filter(a => a.typeId != 11);
      return [...sectionsFields, ...unParentFields];
    },
    dynamicFormChanged() {
      if (this.neglectFirstDynamicFormChange) {
        if (this.caseTypeInfo.responseTemplate) {

          const responseKeys = Object.keys(this.formModel)
            .filter(a => a.split('_').length == 2 && a.endsWith('_response'));

          const responseDynamicFormFieldsFlattered = this.getResponseDynamicFormFieldsFlattered();
          let result = {};
          for (const key of responseKeys) {
            const responseValue = this.formModel[key];
            const field = responseDynamicFormFieldsFlattered.find(a => key == a.name);
            if (field) {
              const fieldProperties = JSON.parse(field.properties || '{}');

              result[responseValue] = [...result[responseValue] || [], {
                label: fieldProperties.fieldLabel,
                name: fieldProperties.fieldKey,
                description: fieldProperties.fieldDescription,
                showCorrectPartText: responseValue == 2 || responseValue == 3,
                showWrongPartText: responseValue == 3,
                responseText: this.formModel[`${fieldProperties.fieldKey}_response_Name`],
                responseCorrectPartText: this.formModel[`${fieldProperties.fieldKey}_correctPart_response`],
                responseWrongPartText: this.formModel[`${fieldProperties.fieldKey}_wrongPart_response`],
              }];
            }
          }

          this.formModel.responseTemplateCorrectResult = result[1];
          this.formModel.responseTemplateWrongResult = result[2];
          this.formModel.responseTemplatePartiallyCorrectResult = result[3];
          this.formModel.responseTemplateUnknownResult = result[4];
          this.formModel.hasCorrectResult = (result[1] || []).length > 0;
          this.formModel.hasWrongResult = (result[2] || []).length > 0;
          this.formModel.hasPartiallyCorrectResult = (result[3] || []).length > 0;
          this.formModel.hasUnknownResult = (result[4] || []).length > 0;
          //this.formModel.requests = this.Val.responseFormDataModel.requests;
          this.formModel.additionalRequests = {
            newRequestVal: this.formModel.newRequestVal,
            newRequestValName: this.formModel.newRequestValName,
            newRequestText: this.formModel.newRequestText,
          };
          this.formModel.additionalRequirement = {
            newRequirementVal: this.formModel.newRequirementVal,
            newRequirementValName: this.formModel.newRequirementValName,
            newRequirementText: this.formModel.newRequirementText,
          };

          this.$set(
            this.formModel,
            'responseReplyNote',
            this.handlebars(this.caseTypeInfo.responseTemplate, this.formModel)
          );
        }
      }
      this.neglectFirstDynamicFormChange = true;
    },
    showModal(id) {
      this.$refs.attachmentModalComponent.showModal(id);
    },
    handleViewAttachment(file) {
      this.$refs.attachmentModalComponent.showAttachment(file);
    },
    handleDeleteAttachment(index = this.activeAttachment) {
      this.formModel.attachments.splice(index, 1);
    },
    attachmentSelected(attachment) {
      this.selectedAttachment = attachment;

      if (attachment && this.$refs.attachmentModalComponent) {
        this.$refs.attachmentModalComponent.showModal();
      }
    },
    attachmentModalClosed() { },
    submitUploadAttachment({ attachment }) {
      this.loading = true;
      const reader = new FileReader();
      const self = this;

      reader.onloadend = () => {
        var b64 = reader.result.replace(/^data:.+;base64,/, '');

        self.uploadAttachment({
          classification: 0,
          documentMetadata: {
            caseId: 0,
            caseCode: 0,
            requestId: 0,
            category: attachment.category,
            fileCategory: attachment.category,
          },
          fileCategory: attachment.category,
          extension: attachment.extension,
          base64FileContent: b64,
        })
          .then(({ data }) => {
            self.formModel.attachments.push({
              fileName: attachment.name,
              extension: attachment.extension,
              sharePointId: data,
              fileCategory: attachment.category,
            });

            this.$refs.attachmentModalComponent.closeModal();
          })
          .catch(err => this.toaster.error(err.message))
          .finally(() => (this.loading = false));
      };

      reader.readAsDataURL(attachment.fileObject);
    },
    validateThenSubmit() {
      this.$refs.responseFormRef.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            this.showConfirmationModal = true;
          } else {
            this.toaster.error(this.local.caseFile.lawsuitReplyForm.missingFieldsErrorMessage);
            resetScroll();
          }
        });
    },
    onSubmit() {
      this.loading = true;
      const payload = {
        caseId: this.caseDetails.id,
        caseObjectKey: this.caseObjectKey,
        caseCode: this.caseDetails.caseCode,
        responseForm: JSON.stringify(this.formModel),
        responseReplyNote: this.formModel.responseReplyNote,
        applicantCasePartyInfo: this.defendants.filter(cp => this.formModel.applicantPartyIds.some(pId => pId == cp.partyId)),
        createdByCasePartyId: this.userCasePartyRoleInCase.casePartyId,
        createdByPartyId: this.userCasePartyRoleInCase.partyId,
        createdByRoleInCaseId: this.userCasePartyRoleInCase.roleInCaseId,
        attachments: this.formModel.attachments,
      };

      this.addLawsuitReplyResponseForm(payload)
        .then(() => {
          this.showConfirmationModal = false;
          this.toaster.success(this.local.caseFile.lawsuitReplyForm.replySentSuccessfully);
          this.requestCodeResult = this.caseObjectKey;
          this.showEvaluationModal = true;
        })
        .finally(() => (this.loading = false));
    },
  },
};

</script>

<style scoped>
.attachments-wrapper {
  margin-right: -12px;
  margin-left: -12px;
}
</style>